import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import {message, Tooltip, Skeleton, Space, Drawer} from 'antd';

import PsContext from '../../context/PsContext';

class Customers extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			dataList: [],
			dataView: [],
			editData: [],
			showSubMenu: false,
		}
	
		this.handleSubMenuClose = this.handleSubMenuClose.bind(this);
		this.handleSubMenuOpen = this.handleSubMenuOpen.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Customers',
			back: true,
			to: '/app',
		});
		this.loadData();
	}
		
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						dataList: res['data'].data,
						dataView: res['data'].data,						
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleSubMenuOpen(record){
		this.setState({
			editData: record,
			showSubMenu: true,
		});
	}
	
	handleSubMenuClose(){
		this.setState({
			editData: [],
			showSubMenu: false,
		});
	}
	
	getUserInfo(field){
		try{
			var d = this.state.editData;
			return d[field];
		}
		catch(er){ }
	}
	
	handleDeleteClick(){
		var $this = this;
		$.confirm({
			title: 'Confirm',
			content: 'Do you want to delete?',
			buttons: {
				Yes:  function(){
					$this.confirmDelete();
				},
				No: function(){ }
			}
		});
	}
	
	confirmDelete(){
		try{
			this.setState({showLoader: true});
			var form = new FormData();
			var uId = this.getUserInfo('id');
			form.append('api', this.context.state.api);
			form.append('i__id', uId);
			axios.post(Api.Url+'v1/customer/remove', form).then(res=>{
				if(res['data'].status=='1'){
					message.success(res['data'].message || 'Success');
					var d = this.state.dataList;
					var index = d.findIndex(function(obj){
						return(obj.id==uId);
					});
					if(index>=-1)
						d.splice(index,1);
					this.setState({
						dataList: d,
						dataView: d,
						showLoader: false,
						editData: [],
						showSubMenu: false,
					});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			});
		}
		catch(error){
			console.log(error);
			this.setState({showLoader: false});
		}
	}
	
	
	render(){

		const skelton = <Space className="mb-20" >			
			  <Skeleton.Input style={{ width: 'calc(100vw)' }} active={true} size={"small"} />
		</Space>;
		return(
		<div className="container" >
			<div data-aos="fade" >
			
				{this.state.showLoader ? <>
					{skelton}
					{skelton}
					{skelton}
				</>	: null}
			
				{this.state.dataView.map((item,i)=>{
					return <div className="card settings-card">
						<div className="card-body">
						  <div className="single-settings d-flex align-items-center justify-content-between">
							<div className="title">
								<div className="font-weight-600" >{item.customer_name}</div>
								<span>{item.customer_address}</span>
							</div>
							<div className="data-content">
							  <div className="font-20" onClick={this.handleSubMenuOpen.bind(this, item)} >
								<i className="icofont-arrow-right"></i>
							  </div>
							</div>
						  </div>
						</div>
					  </div>;
				})
				}
				 
			</div>
			
				<div className="btn-fab-btm-right" >
					<Tooltip title="Add Customer" >
						<Link to="/app/customer/new" className="ant-btn ant-btn-primary ant-btn-circle ant-btn-lg ant-btn-icon-only" >
							<i className="icofont-plus"></i>
						</Link>
					</Tooltip>
				 </div>
				 
				  <Drawer
					  placement={"bottom"}
					  closable={true}
					  onClose={this.handleSubMenuClose} 
					  visible={this.state.showSubMenu}
					  height={'300px'}
					  title={this.getUserInfo('customer_name')}
					>
					
					 <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-empty-file"></i><span>Code</span></div>
						<div className="data-content">{this.getUserInfo('customer_code')}</div>
					  </div>
					  <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-phone"></i><span>Phone</span></div>
						<div className="data-content">{this.getUserInfo('customer_mobile')}</div>
					  </div>
					  <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="lni lni-map-marker"></i><span>Address</span></div>
						<div className="data-content">{this.getUserInfo('customer_address')}</div>
					  </div>
					   <div className="single-profile-data d-flex align-items-center justify-content-between">
						<div className="title d-flex align-items-center"><i className="icofont-notebook"></i><span>Account Details</span></div>
						<div className="data-content">{this.getUserInfo('customer_bank_no')}</div>
					  </div>
					 
					  <Row>
						<Col xs={6} >
						  <div className="push-right" style={{float: 'right'}} >
							<Link 
								className="btn btn-warning btn-md"
								style={{width: '150px'}}
								to={"/app/customer/edit/"+this.getUserInfo('id')} 
							>
								<i className="lni lni-pencil-alt"></i> EDIT
							</Link>
						  </div>
					  </Col>
					  <Col xs={6} >
						   <div className="pull-left" style={{float: 'left'}}  >
							<Button
								type="button"
								size="md"
								variant="danger"
								style={{width: '150px'}}
								onClick={this.handleDeleteClick}
							>
								<i className="lni lni-cross-circle"></i> DELETE
							</Button>
						  </div>
					  </Col>
					 </Row>
					
					</Drawer>
			</div>
		);
	}
	
}
export default Customers;
